<template>
  <div class="card border-0 card-collapse mb-4">
    <div class="card-header border-0 rounded-0 p-0">
      <h3 class="mb-0 fs-5 text-white">
        <a :href="'#' + sectionID" data-bs-toggle="collapse" role="button" :aria-expanded="index === 0 ? 'true' : 'false'"
          :aria-controls="sectionID" :id="sectionID + '_button'" :class="'d-block py-2 px-3 text-white dropdown-bs-toggle' + (index === 0 ? '' : ' collapsed')
            ">{{ sub_section }}</a>
      </h3>
    </div>
    <div :id="sectionID" :class="'card-body bg-gray-100 p-0 collapse' + (index === 0 ? ' show' : '')"
      :aria-labeledby="sectionID + '_button'">
      <div class="table-responsive py-3">
        <table class="table table-sm table-striped mb-0">
          <thead>
            <tr>
              <th></th>
              <th>Description</th>
              <th>CCA</th>
              <th>RC</th>
              <th>Length</th>
              <th>Width</th>
              <th>Height</th>
              <th>Terminal</th>
              <th v-if="getCatalog == 3 || getCatalog == 4">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in productsFormatted" :key="product.item_id" :product="product">
              <td><a :href="product.url" :class="'product-image'"><img :src="product.image_url"
                    :alt="product.item_name" /></a></td>
              <td><a :href="product.url">{{ product.item_name }}</a></td>
              <td v-html="product.cca"></td>
              <td v-html="product.capacity"></td>
              <td v-html="product.length"></td>
              <td v-html="product.width"></td>
              <td v-html="product.height"></td>
              <td v-html="product.terminal"></td>
              <td v-if="getCatalog == 3 || getCatalog == 4" v-html="product.description"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["sub_section", "index", "section", "products"],
    computed: {
      productsFormatted() {
        return this.products.map(product => {
          product.cca = product.cca == "" ? "&nbsp;" : product.cca
          product.capacity = product.capacity == "" ? "&nbsp;" : product.capacity
          product.length = product.length == "" ? "&nbsp;" : product.length
          product.width = product.width == "" ? "&nbsp;" : product.width
          product.height = product.height == "" ? "&nbsp;" : product.height
          product.terminal = product.terminal == "" ? "&nbsp;" : product.terminal
          console.log('product:',product)
          product.description = product.description || ''
          product.description =
            product.description == ""
              ? "&nbsp;"
              : product.description
                .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
                .replace(/\r?\n/g, "<br>")

          return product
        })
      },
      getCatalog() {
        return p_catalog
      },

      sectionID() {
        return this.section.replace(/ /g, "_") + "_card_" + this.index
      },
    },
  }
</script>

<style></style>
